<template>
    <div v-if="showLegalBar" class="d-flex justify-content-end legal-bar ms-auto">
        <a class="d-flex legal-text align-self-center ps-0" @click="showLegalModal">
            {{ legalLabel }}
        </a>

        <FullScreenModal :name="legalLabel" :forceNoOverlay="true">
            <template v-slot:topHeading>
                <h2 class="offer-details-modal-title">
                    {{ this.heading || legalLabel }}
                </h2>
            </template>

            <template v-slot>
                <div v-if="html" class="mt-3" v-html="html"></div>
                <h3 v-else-if="statusMessage" class="mt-3">{{ statusMessage }}</h3>
            </template>
        </FullScreenModal>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { url } from '@js/utilities/url.js'

// lodash components
import trimStart from 'lodash/trimStart'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },

    data() {
        return {
            networkError: null,
            html: null,
            heading: null,
        }
    },

    mounted() {
        this.fetchPageContent()
    },

    computed: {
        legalLabel: function () {
            return this.$t('legal.linkText')
        },
        legalLink: function () {
            if (this.store.state.global.data.legal_text_link) {
                //ensure we dont double up on //
                return `/${trimStart(this.store.state.global.data.legal_text_link, '/')}`
            }

            return null
        },
        showLegalBar: function () {
            return this.legalLabel && this.legalLink
        },
        statusMessage() {
            return this.networkError || 'Loading...'
        },
    },

    methods: {
        showLegalModal: function () {
            this.emitter.emit(this.legalLabel, {
                open: true,
            })
        },
        fetchPageContent: async function () {
            this.networkError = null

            try {
                const response = await axios.get(url(`api/v2/page-data?pagePath=${this.legalLink}`))

                if (response && response.data) {
                    this.html = response?.data?.content
                    this.heading = response?.data?.heading
                }
            } catch (error) {
                this.networkError = 'Error fetching content. Please reload the page.'
                console.error(error)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/variables';
@import '~scss/mixins/rem';

.legal-bar {
    padding: 0;

    .legal-text {
        cursor: pointer;
        color: $text-dark;
        font-size: rem(14px);
        padding-right: 15px;
        font-weight: bold;
    }
}
</style>
